import { createContext, useContext } from 'react'

import { TResumeBuilderForm } from '@/forms/types'

export const ResumeDocumentContext = createContext<
  | {
      formValues: TResumeBuilderForm
    }
  | undefined
>(undefined)

export const useResumeDocumentContext = () => {
  const context = useContext(ResumeDocumentContext)

  if (!context) {
    throw new Error('useResumeDocument must be used within a ResumeDocumentProvider')
  }

  return context
}
